import { INavLinkGroup } from "@fluentui/react";
import { IAuth, IUser, IGoogle, IMicrosoft } from "../auth/interface/IAuth";
import { keyAccess, keyJwt } from "../utils/helpers/helpers";
import { fetchIdentidad } from "./http-common";
import TokenService from "./tokenService";

const urlAuth = "/v1/Login";
const urlAccess = "/v1/Access";

const login = (data: IUser) => {
  return fetchIdentidad.post<IAuth>(`/v1/LoginWeb`, data);
};

const loginGoogle = (data: IGoogle) => {
  return fetchIdentidad.post<IAuth>(`${urlAuth}/Google`, data);
};

const loginMicrosoft = (data: IMicrosoft) => {
  return fetchIdentidad.post<IAuth>(`${urlAuth}/Microsoft`, data);
};

const access = () => {
  return fetchIdentidad.post<INavLinkGroup[]>(
    `${urlAccess}`,
    {},
    { headers: { Authorization: `Bearer ${TokenService.getToken()}` } }
  );
};

const getAccess = () => {
  let c = localStorage.getItem(keyAccess);

  if (c) {
    return JSON.parse(c);
  }

  return null;
};

const getInfoToken = (key: string) => {
  let s = TokenService.getToken();

  if (s) {
    let t: any = JSON.parse(atob(s.split(".")[1]));
    return t[key];
  }

  return null;
};

const verifiedExp = () => {
  let exp = new Date(AuthService.getInfoToken("exp") * 1000);
  let now = new Date();
  if (exp < now) {
    return true;
  }
  return false;
};

const removeToken = () => {
  localStorage.removeItem(keyJwt);
};

const AuthService = {
  login,
  loginGoogle,
  access,
  loginMicrosoft,
  getAccess,
  getInfoToken,
  verifiedExp,
  removeToken,
};

export default AuthService;
